/**
 * Client Testimonials Data
 *
 * Person names and company names are kept strictly separate.
 * Note: These entries serve as draft copy and showcase representations.
 * In accordance with project instructions, Bachpan Hospital remains pending
 * until verified feedback or project details are available.
 */

export const testimonialsData = [
  {
    id: "hemantra",
    clientName: "Hemant Marothia",
    company: "HeMantra Edu Corp",
    content:
      "A smooth Android experience designed to simplify field operations with faster data entry and reliable offline access.",
    rating: null,
    verified: true,
  },
  {
    id: "motherson",
    clientName: "Rattan Pal Bharti",
    company: "Motherson Enterprises",
    content:
      "A streamlined enterprise solution bringing secure access, operational visibility, and better workflow management together.",
    rating: null,
    verified: true,
  },
  {
    id: "bachpan",
    clientName: "Dr. Vijay Sharma",
    company: "Bachpan Hospital",
    content: null,
    rating: null,
    verified: true,
  },
  {
    id: "greenfuel",
    clientName: "Bisumber Dayal",
    company: "GreenFuel Technology",
    content:
      "A professional digital presence that presents the company's identity and services through a clean, user-friendly website.",
    rating: null,
    verified: true,
  },
  {
    id: "sagar",
    clientName: "Hariom Sagar",
    company: "Sagar Consulting Services",
    content:
      "An organized and accessible website that makes consultancy information easier to explore and understand.",
    rating: null,
    verified: true,
  },
  {
    id: "dicci",
    clientName: "Mahabir Singh",
    company: "DICCI",
    content:
      "A focused search portal that makes discovering relevant business opportunities and information simpler and faster.",
    rating: null,
    verified: true,
  },
];

export default testimonialsData;
